import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ContactPage from '../pages/contacto/page';
import ServiciosPage from '../pages/servicios/page';
import CreacionCorporacionesPage from '../pages/servicios/creacion-corporaciones/page';
import ReparacionCreditoPage from '../pages/servicios/reparacion-credito/page';
import ObtencionFundingPage from '../pages/servicios/obtencion-funding/page';
import MentoriasPersonalizadasPage from '../pages/servicios/mentorias-personalizadas/page';
import NuestraHistoria from '../pages/nuestra-historia/page';

const Home = lazy(() => import('../pages/home/page'));
const Servicios = lazy(() => import('../pages/servicios/page'));
const CasosExito = lazy(() => import('../pages/casos-exito/page'));
const Eventos = lazy(() => import('../pages/eventos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/servicios',
    element: <Servicios />,
  },
  {
    path: '/casos-exito',
    element: <CasosExito />,
  },
  {
    path: '/eventos',
    element: <Eventos />,
  },
  {
    path: '/contacto',
    element: <ContactPage />
  },
  {
    path: '/servicios/creacion-corporaciones',
    element: <CreacionCorporacionesPage />
  },
  {
    path: '/servicios/reparacion-credito',
    element: <ReparacionCreditoPage />
  },
  {
    path: '/servicios/obtencion-funding',
    element: <ObtencionFundingPage />
  },
  {
    path: '/servicios/mentorias-personalizadas',
    element: <MentoriasPersonalizadasPage />
  },
  {
    path: '/nuestra-historia',
    element: <NuestraHistoria />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
